import { Table } from 'antd';
import { any } from 'prop-types';
import FileDownload from '@/components/FileDownload/FileDownload';

export default function EquipmentExpandTable({ data }) {
  const columns = [
    {
      title: '设施设备名称', dataIndex: 'equipName', width: 100,
    },
    { title: '单位', dataIndex: 'unit', width: 80 },
    { title: '设备型号', dataIndex: 'equipType', width: 100 },
    { title: '单价(万元)', dataIndex: 'unitPrice', width: 100 },
    { title: '数量', dataIndex: 'num', width: 80 },
    { title: '总额(万元)', dataIndex: 'totalAmount', width: 100 },
    { title: '省级专项资金(万元)', dataIndex: 'provincialSubsidyFunds', width: 100 },
    { title: '市县资金(万元)', dataIndex: 'cityFunding', width: 90 },
    { title: '企业自筹资金(万元)', dataIndex: 'selfFunding', width: 100 },
    { title: '其他资金(万元)', dataIndex: 'otherFunding', width: 90 },
    {
      title: '是否完成',
      dataIndex: 'finishFlag',
      width: 50,
      render: (text) => <span>{text === 1 ? '是' : '否'}</span>,
    },
    {
      title: '支付凭证',
      dataIndex: 'fileList1',
      width: 150,
      render: (text) => (
          <div className="table-file-download">
            {text?.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <FileDownload key={index} appendixName={item.fileName} fileUrl={item.fileUrl} />
            ))}
          </div>
      ),
    },
    {
      title: '工程凭证',
      dataIndex: 'fileList2',
      width: 150,
      render: (text) => (
          <div className="table-file-download">
            {text?.map((item, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <FileDownload key={index} appendixName={item.fileName} fileUrl={item.fileUrl} />
            ))}
          </div>
      ),
    },
  ];

  return (
    <Table rowKey={(row, index) => String(index)} columns={columns} dataSource={data} pagination={false} size="small" bordered />
  );
}

EquipmentExpandTable.propTypes = {
  data: any,
};
